import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useRecoleccionGestorTransporte from "../../../hooks/administrador/recoleccion/useRecoleccionGestorTransporte";
import "../../../styles/administrador.css";

const RecoleccionGestorTransporte = ({
  year,
  mes,
  token,
  idAdministrador,
  provinciaSeleccionada,
  ciudadSeleccionada,
}) => {
  const chartRef = useRef(null);

  const { data, loading, error } = useRecoleccionGestorTransporte(
    year,
    mes,
    token,
    idAdministrador,
    provinciaSeleccionada,
    ciudadSeleccionada
  );

  useEffect(() => {
    if (loading || !chartRef.current) return;

    if (error || !Array.isArray(data) || data.length === 0) {
      if (chartRef.current) {
        chartRef.current.innerHTML =
          "<p style='text-align: center; color: black;'>No hay datos disponibles</p>";
      }
      return;
    }

    const chartDom = chartRef.current;
    let myChart = echarts.getInstanceByDom(chartDom);
    if (myChart) myChart.dispose();
    myChart = echarts.init(chartDom);

    const colors = ["#d1dc5a", "#6ac5cb", "#45444e", "#a3b85b", "#3a6b74"];

    const meses = [...new Set(data.map((item) => item.mes))].sort((a, b) => {
      const mesesOrden = {
        Enero: 1,
        Febrero: 2,
        Marzo: 3,
        Abril: 4,
        Mayo: 5,
        Junio: 6,
        Julio: 7,
        Agosto: 8,
        Septiembre: 9,
        Octubre: 10,
        Noviembre: 11,
        Diciembre: 12,
      };
      return mesesOrden[a] - mesesOrden[b];
    });

    const transportistas = [
      ...new Set(data.map((item) => item.razon_social)),
    ].filter(Boolean);
    const mesesAbreviados = meses.map((mes) =>
      mes.substring(0, 3).toUpperCase()
    );

    const series = transportistas.map((transportista, index) => {
      const dataSeries = meses.map((mes) => {
        const item = data.find(
          (d) => d.mes === mes && d.razon_social === transportista
        );
        return item ? parseInt(item.Recolecciones) || 0 : 0;
      });

      return {
        name: transportista,
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: dataSeries,
        itemStyle: {
          color: colors[index % colors.length],
        },
      };
    });

    const totalRecolecciones = data.reduce(
      (sum, item) => sum + (parseInt(item.Recolecciones) || 0),
      0
    );

    const option = {
      title: {
        text: "Recolección por gestor de transporte",
        left: "center",
        subtext: `TOTAL RECOLECCIONES: ${totalRecolecciones.toLocaleString()}`,
        subtextStyle: {
          fontWeight: "bold",
          fontSize: "12px",
        },
        textStyle: {
          fontSize: 18,
          fontWeight: "bold",
        },
      },
      tooltip: {
        trigger: "axis",
        confine: true,
        axisPointer: {
          type: "shadow",
        },
        formatter: function (params) {
          let tooltip = `<b>${params[0].axisValueLabel}</b><br/>`;
          let total = 0;

          params.forEach((param) => {
            if (param.value > 0) {
              // Formatear el nombre con saltos de línea cada dos palabras
              const nombreTransportista = param.seriesName;
              const palabras = nombreTransportista.split(" ");
              let nombreFormateado = "";

              for (let i = 0; i < palabras.length; i += 2) {
                if (i + 1 < palabras.length) {
                  nombreFormateado +=
                    palabras[i] + " " + palabras[i + 1] + "<br/>";
                } else {
                  nombreFormateado += palabras[i];
                }
              }

              tooltip += `${
                param.marker
              } <span>${nombreFormateado}</span>: <b>${param.value.toLocaleString()} recolecciones</b><br/>`;
              total += param.value;
            }
          });

          tooltip += `<br/><b>Total: ${total.toLocaleString()} Recolecciones</b>`;
          return tooltip;
        },
      },
      legend: {
        data: transportistas,
        bottom: 10,
        type: "scroll",
        width: "80%",
        formatter: function (name) {
          if (name.length > 20) {
            return name.substring(0, 20) + "...";
          }
          return name;
        },
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "20%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: mesesAbreviados,
        axisLabel: {
          fontSize: 10,
          fontWeight: "bold",
        },
      },
      yAxis: {
        type: "value",
        name: "",
        axisLabel: {
          formatter: function (value) {
            if (value >= 1000) return (value / 1000).toFixed(0) + "k";
            return value;
          },
        },
        splitLine: {
          lineStyle: {
            type: "dashed",
          },
        },
      },
      color: colors,
      series: series,
    };

    myChart.setOption(option);

    const updateChart = () => {
      myChart.resize();
    };

    window.addEventListener("resize", updateChart);

    return () => {
      window.removeEventListener("resize", updateChart);
      if (myChart && !myChart.isDisposed()) {
        myChart.dispose();
      }
    };
  }, [data, loading, error]);

  if (loading) {
    return (
      <div className="grafica loading">
        Cargando datos de recolección por gestor de transporte...
      </div>
    );
  }

  return <div className="grafica" ref={chartRef}></div>;
};

export default RecoleccionGestorTransporte;
